(function (d) {
    var trinityEl = d.querySelector(".trinityAudioPlaceholder");
    if (!trinityEl) return;

    var data = trinityEl.dataset;
    var playerId = data.playerId;

    if (window.TRINITY_PLAYER && TRINITY_PLAYER.players[playerId]) {
        TRINITY_PLAYER.api.createPlayer(playerId);
    } else {
        var script = d.createElement("script");
        var scriptUrl = "https://trinitymedia.ai/player/trinity/" + data.unitId + "/?pageURL=" + data.pageUrl + "&partner=Flex" + data.fabParam;

        scriptUrl += "&textSelector=" + encodeURIComponent(btoa(data.textSelector));
        script.dataset.playerId = playerId;
        script.src = scriptUrl;
        d.body.appendChild(script);
    }
})(document);